import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import { getMeta } from "../helpers";

export default class extends Controller {
    static targets = ["input"]
    static values = { placeholder: String }
    connect() {
        this.initTomSelect()
        this.currentLanguageCode = getMeta('wp-language').split('-')[0];

        // TomSelect's background can't be overriden with styles, so we need to do it with JS
        setTimeout(() => {
            const controlElements = this.element.querySelectorAll('.ts-control');
            controlElements.forEach(el => {
                const existingIcon = el.querySelector('.search-icon');
                if (existingIcon) existingIcon.remove();

                const searchIcon = document.createElement('div');
                searchIcon.className = 'search-icon';
                searchIcon.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;

                el.appendChild(searchIcon);
            });

            const wrapperElements = this.element.querySelectorAll('.ts-wrapper');
            wrapperElements.forEach(el => {
                el.style.setProperty('background-color', 'transparent', 'important');
            });
        }, 0);
    }

    initTomSelect() {
        if (this.tomSelect) {
            this.tomSelect.destroy();
        }

        this.tomSelect = new TomSelect(this.inputTarget, {
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            placeholder: this.placeholderValue,
            dropdownParent: this.element.parent,
            maxItems: 1,
            mode: 'single',
            closeAfterSelect: true,
            onItemAdd: () => {
                this.tomSelect.control_input.style.width = '0';
                this.tomSelect.control_input.style.height = '0';
                this.tomSelect.control_input.style.opacity = '0';
                this.tomSelect.control_input.style.padding = '0';
                this.tomSelect.control_input.style.border = 'none';
                this.tomSelect.control_input.setAttribute('disabled', 'disabled');
            },
            load: (query, callback) => {
                if (!query.length) return callback();

                fetch(`/wp-json/api/search-coaches?search=${encodeURIComponent(query)}&rest_language=${this.currentLanguageCode}`)
                    .then(response => response.json())
                    .then(result => {
                        if (result.success && result.data) {
                            callback(result.data);
                        } else {
                            callback();
                        }
                    }).catch(() => {
                    callback();
                });
            },
            render: {
                option: function(item, escape) {
                    return `<div class="option">
                            <span class="name">${escape(item.name)}</span>
                        </div>`;
                },
                item: function(item, escape) {
                    return `<div class="item">${escape(item.name)}</div>`;
                },
                no_results: function() {
                    return '<div class="no-results">Rezultatų nerasta</div>';
                },
            },

            onChange: (value) => {
                if (value) {
                    this.refreshWithCoachId(value);
                }
            },
            onDelete: (values) => {
                this.refreshWithCoachId(null);
            },
        });
    }

    refreshWithCoachId(coachId) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        if (coachId) {
            params.set('coach', coachId);
        } else {
            params.delete('coach');
        }

        url.search = params.toString();
        window.location.href = url.toString();
    }

    disconnect() {
        if (this.tomSelect) {
            this.tomSelect.destroy()
        }
    }
}
